export const ST_PARENT_ID_SESSION_KEY = 'creditSelection.stParentId';
